(() => {
  'use strict';

  const debugMode = new URLSearchParams(window.location.search).get('tec11_debug');
  const debug = ['contact', 'contact_test'].includes(debugMode);
  const report = (status) => { if (debug) console.info('TEC11 contact:', status); };
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], (error) => {
      report(error ? 'privacy_unavailable' : 'privacy_ready');
    });
  }

  function pageType() {
    const path = window.location.pathname;
    if (path.startsWith('/products/')) return 'product';
    if (path.startsWith('/collections/')) return 'collection';
    const pages = {
      '/': 'home',
      '/pages/reparacion': 'repair',
      '/pages/vende-tu-dispositivo': 'trade_in',
      '/pages/contact': 'contact',
      '/pages/para-tu-negocio': 'business',
      '/pages/quienes-somos': 'about'
    };
    return pages[path] || 'other';
  }

  function buttonLocation(link) {
    if (link.closest('footer, [id$="__tec-footer"]')) return 'footer';
    if (link.closest('header, [id$="__tec-header"]')) return 'header';
    if (link.closest('#tec11-recompra')) return 'trade_in';
    if (link.closest('.tec-product-consult')) return 'product';
    return 'page';
  }

  document.addEventListener('click', (event) => {
    if (!event.isTrusted || event.defaultPrevented || event.button !== 0) return;
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    let destination;
    try {
      destination = new URL(link.href, window.location.origin);
    } catch {
      return;
    }
    if (destination.protocol !== 'https:' || !['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(destination.hostname)) return;
    if (debugMode === 'contact_test') event.preventDefault();
    link.target = '_blank';
    link.relList.add('noopener');
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.marketingAllowed !== 'function') { report('privacy_unavailable'); return; }
    if (privacy.marketingAllowed() !== true) { report('marketing_denied'); return; }
    if (typeof privacy.analyticsProcessingAllowed !== 'function' || privacy.analyticsProcessingAllowed() !== true) { report('analytics_denied'); return; }
    if (typeof window.fbq !== 'function') { report('native_meta_unavailable'); return; }
    const eventID = window.crypto.randomUUID();
    const parameters = {
      contact_channel: 'whatsapp',
      interaction: 'click',
      button_location: buttonLocation(link),
      page_type: pageType(),
      schema_version: 1
    };
    try {
      window.fbq('trackSingleCustom', '1314401306440672', 'WhatsAppClick', parameters, {eventID});
      report('sent_to_native_meta');
    } catch { report('native_meta_failed'); }
  });
})();
